(() => {
    document.addEventListener('alpine:init', () => {
      // Linked Products variant switching
      Alpine.data('LinkedProducts', (type) => ({
        linkedProductsType: '',
        $section: null,
        $products: [],
        products: [],
        hasSpecs: false,
        init() {
          let am = this;
          am.linkedProductsType = type;
  
          document.addEventListener('init-LinkedProducts', (e) => {
            if (am.$section) return;
  
            am.$section = e.target;
            am.$products = [...am.$section.querySelectorAll('[data-linked-product]')];
  
            // init products on page load
            (async () => {
              let px_products = am.$products.map(($item) => {
                let handle = $item.dataset.linkedProduct;
                return fetch(`/products/${handle}.js`).then(res => res.json());
              });
  
              am.products = await Promise.all(px_products);
              am.UpdateLinkedProductUrls();
            })();
          });
          subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
            am.UpdateLinkedProductUrls(e.data.variant.options);
          });
        },
  
        UpdateLinkedProductUrls(current_values) {
          let am = this;
  
          if (!am.products.length) return;
  
          am.$products.forEach(($product) => {
            let handle = $product.dataset.linkedProduct;
            let product = am.products.find(p => p.handle == handle);
  
            if (!product) return;
  
            if (!current_values) {
              current_values = JSON.parse($product.dataset.current_values);
            }
  
            let optionIdsToMatch = [1, 2, 3];
            if (am.linkedProductsType) {
              // exclude option from matching
              optionIdsToMatch = optionIdsToMatch.filter((id) => product.options.map(opt => opt.name).indexOf(am.linkedProductsType) !== (id - 1));
            }
  
            let valuesToMatch = optionIdsToMatch.map((id) => current_values[(id - 1)]);
  
            let matching_variant = product.variants.find((v) => {
              let v_options = optionIdsToMatch.map((id) => v[`option${id}`]).join('/');
              return v_options == valuesToMatch.join('/')
            });
            if (!matching_variant) return;
            $product.setAttribute('href', `/products/${handle}?variant=${matching_variant.id}`);
  
            // apply soldout class if not available
            const shapeLabel = $product.querySelector('label')
            if (shapeLabel) {
              shapeLabel.classList.toggle('disabled', !(matching_variant && matching_variant.available));
            }
          });
        }
      }));
    })
  })()


class SizeDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    
    const overlay = this.querySelector('#SizeDrawer-Overlay');
    if (overlay) {
      overlay.addEventListener('click', this.close.bind(this));
    }
    
    // Add this to handle your close button class name
    const closeButton = this.querySelector('.size-drawer-button');
    if (closeButton) {
      closeButton.addEventListener('click', this.close.bind(this));
    }
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    
    // Upgrade all custom elements when drawer opens
    customElements.upgrade(this);
    
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.querySelector('.drawer__inner') || this;
        const focusElement = this.querySelector('.size-drawer-button') || this.querySelector('.drawer__inner');
        if (focusElement && typeof trapFocus === 'function') {
          trapFocus(containerToTrapFocusOn, focusElement);
        }
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    if (this.activeElement && typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.activeElement);
    }
    document.body.classList.remove('overflow-hidden');
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('size-drawer', SizeDrawer);
  
if (!customElements.get('size-chart-trigger')) {
  customElements.define(
    'size-chart-trigger',
    class SizeChartTrigger extends HTMLElement {
      constructor() {
        super();
        
        // Get the button inside the trigger element
        const button = this.querySelector('button');
        
        if (button) {
          // Add click event to trigger button
          button.addEventListener('click', (evt) => {
            evt.preventDefault();
            evt.stopPropagation();
            
            // Try multiple ways to find the drawer
            let sizeDrawer = null;
            
            // First try to find it as a sibling
            if (this.parentNode) {
              sizeDrawer = this.parentNode.querySelector('size-drawer');
            }
            
            // If not found, try the whole document
            if (!sizeDrawer) {
              sizeDrawer = document.querySelector('size-drawer');
            }
            
            if (sizeDrawer) {
              console.log('Found size drawer, showing it');
              sizeDrawer.open(button);
            } else {
              console.error('Size drawer not found');
            }
          });
        }
      }
    }
  );
}


// Product Shopify Similar Styles Custom Element
// Replaces Rebuy with Shopify's native Product Recommendations API.
// API docs: https://shopify.dev/docs/api/ajax/reference/product-recommendations
//
// Key differences from Rebuy's API response shape:
//   - prices are in cents (e.g. 6100 = $61.00)
//   - product.images is an array of URL strings, NOT objects
//   - variant.featured_image IS a full object with .src, .alt, .width, .height
//   - colour is not always option1 — we detect the colour option by name

class ProductShopifySimilarStyles extends HTMLElement {

  connectedCallback() {
    return (async () => {
      try {
        const template = this.querySelector('template#productListCardTemplate');
        if (!template) {
          console.warn('[ShopifySimilarStyles] Card template not found');
          return;
        }

        const products = await this.getData();

        if (products && products.length > 0) {
          products.forEach((product) => {
            if (product?.id) {
              const card = this.createProductCardItem(product);
              if (card) this.appendChild(card);
            }
          });
          this.setAttribute('loaded', 'true');
        } else {
          // No recommendations — hide so we don't leave an orphan heading
          this.style.display = 'none';
        }
      } catch (error) {
        console.warn('[ShopifySimilarStyles] Error loading component:', error);
      }
    })();
  }

  // ------------------------------------------------------------------
  // Data fetching
  // ------------------------------------------------------------------

  async getData() {
    const productId = this.dataset.productId;
    if (!productId) {
      console.warn('[ShopifySimilarStyles] Missing productId');
      return [];
    }

    // /recommendations/products.json is the AJAX JSON endpoint.
    // Do NOT use routes.product_recommendations_url — that is the section-rendering
    // endpoint which expects a section_id and returns HTML, causing a 422.
    const url = `/recommendations/products.json?product_id=${productId}&limit=6&intent=related`;

    const response = await fetch(url);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);

    const data = await response.json();
    const products = data.products || [];

    // Filter out Carkella-vendor products (mirrors the related-products section logic)
    return products
      .filter((p) => p.vendor?.toLowerCase() !== 'carkella')
      .slice(0, 3);
  }

  // ------------------------------------------------------------------
  // Price formatting — Shopify AJAX prices are in cents
  // ------------------------------------------------------------------

  formatPrice(priceCents) {
    if (priceCents == null) return '';
    const amount = Number(priceCents) / 100;
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD',
      minimumFractionDigits: 2,
    }).format(amount);
  }

  // ------------------------------------------------------------------
  // Find which option index holds the colour.
  // Falls back to option2 (if 2+ options exist) then option1.
  // ------------------------------------------------------------------

  getColorOptionKey(product) {
    const colorNames = ['color', 'colour'];
    if (product.options) {
      for (const opt of product.options) {
        if (colorNames.includes(opt.name.toLowerCase())) {
          return `option${opt.position}`; // e.g. "option2"
        }
      }
    }
    return product.options?.length > 1 ? 'option2' : 'option1';
  }

  // ------------------------------------------------------------------
  // Build one entry per unique colour value, carrying the first
  // variant that matches and its featured_image (a full object).
  // ------------------------------------------------------------------

  buildColorVariants(product) {
    const colorKey = this.getColorOptionKey(product);
    const seen = new Set();
    const result = [];

    for (const v of product.variants) {
      const colorValue = v[colorKey];
      if (!colorValue || seen.has(colorValue)) continue;
      seen.add(colorValue);
      result.push({
        colorValue,
        price: v.price,
        compare_at_price: v.compare_at_price,
        variantId: v.id,
        // featured_image is a full object {src, alt, width, height, variant_ids}
        featuredImage: v.featured_image || null,
      });
    }
    return result;
  }

  // ------------------------------------------------------------------
  // Card building
  // ------------------------------------------------------------------

  createProductCardItem(product) {
    if (!product?.variants?.length) return null;

    const firstVariant = product.variants.find((v) => v?.price != null);
    if (!firstVariant) return null;

    const template = this.querySelector('template#productListCardTemplate');
    if (!template?.content?.firstElementChild) return null;

    const cardElement = template.content.firstElementChild.cloneNode(true);

    // Title & price
    const titleEl = cardElement.querySelector('.product-list-card__title');
    const priceEl = cardElement.querySelector('.product-list-card__price');
    if (titleEl) {
      titleEl.textContent = product.title || '';
      titleEl.id = `title-shopify-${product.id}`;
    }
    if (priceEl) priceEl.textContent = this.formatPrice(firstVariant.price);

    // Modal opener & quick-shop button
    const modalOpener = cardElement.querySelector('modal-opener');
    const button = cardElement.querySelector('.product-list-card__button');
    if (modalOpener && button) {
      modalOpener.setAttribute('data-modal', `#QuickAdd-shopify-${product.id}`);
      button.setAttribute('data-product-url', this.getProductLink(product.handle, firstVariant.id));
      button.setAttribute('aria-haspopup', 'dialog');
      button.setAttribute(
        'aria-labelledby',
        `quick-add-shopify-${product.id}-submit title-shopify-${product.id}`
      );
      button.id = `quick-add-shopify-${product.id}-submit`;
    }

    // Queue modal creation (deferred to avoid layout thrashing)
    setTimeout(() => {
      try {
        const modal = this.createDawnQuickAddModal(product);
        if (modal) {
          const wrapper = document.createElement('div');
          wrapper.className = 'shopify-section';
          wrapper.id = `shopify-section-similar-${product.id}`;
          wrapper.appendChild(modal);
          document.body.appendChild(wrapper);
        }
      } catch (err) {
        console.warn('[ShopifySimilarStyles] Error creating modal:', err);
      }
    }, 500);

    // Product links
    this.updateProductLink(cardElement, product);

    // Hero image
    // variant.featured_image is a full object {src, alt, ...}
    // product.images is just an array of URL strings — don't use it for <img>
    const heroImg = firstVariant.featured_image;
    const imgContainer = cardElement.querySelector('.product-list-card__image');
    if (imgContainer) {
      if (heroImg?.src) {
        const el = this.createProductCardImage(heroImg);
        if (el) imgContainer.appendChild(el);
      } else if (product.featured_image) {
        // product.featured_image is a protocol-relative string e.g. "//cdn.shopify.com/..."
        const el = document.createElement('img');
        const src = String(product.featured_image);
        el.src = src.startsWith('//') ? `https:${src}` : src;
        el.alt = product.title || '';
        imgContainer.appendChild(el);
      }
    }

    // Color swatches
    const colorVariants = this.buildColorVariants(product);
    const displayVariants = colorVariants.slice(0, 4);
    const swatchContainer = cardElement.querySelector('.product-list-card__color-swatches');

    if (swatchContainer) {
      displayVariants.forEach((variant, index) => {
        const swatch = this.createColorSwatch(variant, index, cardElement, product);
        if (swatch) swatchContainer.appendChild(swatch);
      });

      const extra = colorVariants.length - displayVariants.length;
      if (extra > 0) {
        const extraSpan = this.createExtraColorsSpan(extra);
        if (extraSpan) swatchContainer.appendChild(extraSpan);
      }
    }

    return cardElement;
  }

  // ------------------------------------------------------------------
  // Helpers
  // ------------------------------------------------------------------

  getProductLink(handle, variantId) {
    if (!handle) return '#';
    return `/products/${handle}${variantId ? `?variant=${variantId}` : ''}`;
  }

  updateProductLink(cardElement, product, variantId) {
    cardElement.querySelectorAll('[data-product-link]').forEach((el) => {
      el.setAttribute('href', this.getProductLink(product.handle, variantId));
    });
  }

  deselectSwatches(cardElement) {
    cardElement.querySelectorAll('.variant-swatch').forEach((s) => s.classList.remove('selected'));
  }

  createProductCardImage(image) {
    if (!image?.src) return null;
    const img = document.createElement('img');
    const src = String(image.src);
    img.src = src.startsWith('//') ? `https:${src}` : src;
    if (image.alt) img.alt = image.alt;
    if (image.width) img.width = image.width;
    if (image.height) img.height = image.height;
    return img;
  }

  createColorSwatch(variant, index, cardElement, product) {
    const swatchTemplate = this.querySelector('template#productSwatchTemplate');
    if (!swatchTemplate?.content?.firstElementChild) return null;

    const swatch = swatchTemplate.content.firstElementChild.cloneNode(true);
    if (index === 0) swatch.classList.add('selected');

    const labelEl = swatch.querySelector('.variant-swatch__label');
    if (labelEl) labelEl.textContent = `${product.title}-${variant.colorValue}`;

    // variant.featuredImage is a full object — use directly for background
    const img = variant.featuredImage;
    if (img?.src) {
      const src = img.src.startsWith('//') ? `https:${img.src}` : img.src;
      swatch.setAttribute('data-image', src);
      swatch.setAttribute('data-image-alt', img.alt || '');
      swatch.style.backgroundImage = `url(${src})`;
    }

    swatch.setAttribute('data-variant-id', String(variant.variantId));
    swatch.setAttribute('data-price', this.formatPrice(variant.price));
    if (variant.compare_at_price) {
      swatch.setAttribute('data-compare-at-price', this.formatPrice(variant.compare_at_price));
    }

    swatch.addEventListener('click', () => {
      this.deselectSwatches(cardElement);
      swatch.classList.add('selected');

      this.updateProductLink(cardElement, product, swatch.dataset.variantId);

      const quickAddBtn = cardElement.querySelector('.product-list-card__button');
      if (quickAddBtn) {
        quickAddBtn.setAttribute(
          'data-product-url',
          this.getProductLink(product.handle, swatch.dataset.variantId)
        );
      }

      const imgEl = cardElement.querySelector('.product-list-card__image img');
      if (imgEl && swatch.dataset.image) {
        imgEl.src = swatch.dataset.image;
        imgEl.alt = swatch.dataset.imageAlt || '';
      }

      const priceEl = cardElement.querySelector('.product-list-card__price');
      if (priceEl) {
        priceEl.textContent = swatch.dataset.compareAtPrice || swatch.dataset.price;
      }
    });

    return swatch;
  }

  createExtraColorsSpan(count) {
    const span = document.createElement('span');
    span.textContent = `+${count}`;
    span.classList.add('extra-colors-notice');
    return span;
  }

  createDawnQuickAddModal(product) {
    if (!product?.id || !product?.title) return null;
    const safeTitle = product.title.replace(/"/g, '&quot;');
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = `<quick-add-modal id="QuickAdd-shopify-${product.id}" class="quick-add-modal"><div role="dialog" aria-label="Choose product options for ${safeTitle}" aria-modal="true" class="quick-add-modal__content global-settings-popup" tabindex="-1"><button id="ModalClose-shopify-${product.id}" type="button" class="quick-add-modal__toggle" aria-label="Close"><svg class="icon icon-close" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M17.25 1.78125L16.2188 0.75L9 7.96875L1.78125 0.75L0.75 1.78125L7.96875 9L0.75 16.2188L1.78125 17.25L9 10.0312L16.2188 17.25L17.25 16.2188L10.0312 9L17.25 1.78125Z" fill="currentColor"/></svg></button><div id="QuickAddInfo-shopify-${product.id}" class="quick-add-modal__content-info"></div></div></quick-add-modal>`;
    return tempDiv.firstElementChild;
  }
}

customElements.define('product-shopify-similar-styles', ProductShopifySimilarStyles);